import { ChangeEventHandler, JSX } from "react";
import { FormProps } from "./FormProps";
interface SelectDataProps extends FormProps {
  option: React.ReactNode;
  onChange?: ChangeEventHandler<HTMLSelectElement> | undefined;
  readonly?: boolean;
  labelDisable?: boolean;
  showStaticOption?: boolean;
  staticOption?: string;
}
export default function SelectForm({
  label,
  className,
  value,
  name,
  onChange,
  id,
  styleLabel,
  option,
  readOnly = false,
  showStaticOption,
  staticOption,
  labelDisable,
  ...props
}: SelectDataProps): JSX.Element {
  return (
    <div className="w-full mb-3">
      {!labelDisable && label && (
        <label
          htmlFor={id}
          className={` ${styleLabel || "block text-sm/6 font-medium text-left"}`}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <select
        {...props}
          id={id}
          name={name}
          value={value}
          disabled={readOnly}
          onChange={onChange}
          className={`w-full grow py-[10.5px] pl-3 pr-3 truncate border-[1px] placeholder:text-gray-400 sm:text-sm/6 border-primary-900 shadow-sm border-opacity-50 rounded-lg text-base ${className}`}
        >
          {showStaticOption ? (
            <option value="">{staticOption}</option>
          ) : (
            <option value="" hidden>
              Select {label?.toLowerCase()}
            </option>
          )}
          {option}
        </select>
      </div>
    </div>
  );
}

